import IThresholdDataRepository from '../infractructure/repositories/iThresholdDataRepository';
import ThresholdDataRepository from '../infractructure/repositories/thresholdDataRepository';

class GetthresholdService {
  private readonly _jitRepository: IThresholdDataRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute(queryParams: { workshop_id: string }) {
    return this._jitRepository
      .getThresholdData({ queryParams })
      .then((res) => res)
      .catch((error: any) => {
        // Si es 404, devolver lista vacía
        if (error.message === 'Error: 404') {
          return [];
        }

        // Propagar otros errores
        throw error;
      });
  }
}

export default new GetthresholdService({ repository: ThresholdDataRepository });

export { GetthresholdService };
